import React from 'react';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

import { Benefit } from './Benefit';

import { useStyles } from './styles';

const BENEFITS = [
  {
    title: 'Check payment reliability in seconds',
    description: 'Access real supplier feedback on how companies actually pay.',
  },
  {
    title: 'Understand delay patterns',
    description: 'Identify recurring issues like cash flow problems or admin bottlenecks.',
  },
  {
    title: 'Reduce financial risk',
    description: 'Avoid clients who harm your cash flow.',
  },
  {
    title: 'Make smarter business decisions',
    description: 'Choose partners based on real experience — not promises.',
  },
  {
    title: 'Contribute and gain access',
    description: 'Earn profile views by sharing your experience',
  },
];

export const Benefits = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Box mb={8}>
        <Typography className={classes.title}>Why use RIABU before signing a contract?</Typography>
      </Box>
      <Box className={classes.benefitsList}>
        {BENEFITS.map(({ title, description }) => (
          <Benefit key={title} title={title} description={description} />
        ))}
      </Box>
    </div>
  );
};
